module.exports = __webpack_public_path__ + "static/media/d_image.fb198975.JPG";